const promo = {
  /**
   * 选择商城的label
   */
  filterText: 'Brand',
  filterText_: 'Shop',
  add: 'Add',
  /**
   * 活动类型的label
   */
  promoTypeLabel: 'Promo Type',
  /**
   * 未选择时的提示语
   */
  promoTypePlacement: 'All',

  button: {
    export: 'Download',
    reset: 'Reset',
    submit: 'Submit',
    promoExport: 'Promo Info',
    skuExport: 'SKU Promo Details',
    skuExportMsg: 'Please select the shops',
  },
  tableTitle: 'Promo Datails',
  /**
   * 商城活动页面标题前缀
   */
  shopPageTitle: '',
  /**
   * 品牌活动页面标题前缀
   */
  brandPageTitle: '',
  table: {
    promoInfoCH: 'Promo Info (CH)',
    promoInfoEN: 'Promo Info (EN)',
    startDate: 'Start Date',
    endDate: 'End Date',
    disscount: 'Discount Value',
    promoType: 'Promo Type',
    skuAmt: 'SKU Amt',
    brandsAmt: 'Brands Amt',
    shopName: 'Shop Name',
  },
  modal: {
    skuModal: {
      title: 'SKU',
      table: {
        image: 'Image',
        code: 'Code',
        name: 'Name',
        brand: 'Brand',
        price: 'Price',
        msg: `(1)Click to view prices and price comparsion info in monitored shops.
        (2)Retail Price (Ret-p)：
        Retail price is the price displayed for sale on the official website of the mall and no promotion (including but not limited to discounts, rebates, etc.) is included.
        (3)Optimal Price (Dis-Price)：
        The optimal price is the final price after the best combination of all discount (including but not limited to discounts, rebates, etc.)`,
      },
      skuTable: {
        shopName: 'Shop Name',
        cur: 'Cur',
        retP: 'Ret-p',
        retPCurrency: 'Ret-p({0})',
        optPCountry: 'Dis-Price({0})',
      },
    },
    selectShopModal: {
      title: 'Select Shop',
    },
    selectBrandModal: {
      title: 'Select Brand',
    },
    brandModal: {
      title: 'Brand List',
      table: {
        brand: 'Brand',
        skuAmount: 'SKU Amount',
        SKUDetails: 'SKU Details',
      },
      subTable: {
        image: 'Image',
        code: 'Code',
        brand: 'Brand',
        operation: 'Operation',
        operationBtn: 'View',
      },
    },
    detailModal: {
      title: 'Details',
      table: {
        name: 'Shop Name',
        price: 'Retai Price',
        usd: 'USD',
        discount: 'Dis-Price',
        index: 'Index',
        priceGrading: 'Price Grading',
      },
    },
    downloadModal: {
      title: 'Export Activity Data',
      form: {
        choose: 'Export SKU Details',
        text: 'To prevent exporting data beyond the Excel maximum limit, the sku export condition can only export data for one day',
        yes: 'Yes',
        no: 'No',
        time: 'Timeframe',
      },
      table: {
        ch: 'Promo(CH)',
        en: 'Promo(EH)',
        type: 'Promo Type',
        start: 'Start Date',
        end: 'End Date',
        cheap: 'Promo Discount',
        code: 'Code',
        brand: 'Brand',
        detail: 'Shop Name',
        price: 'Ret-price',
      },
    },
  },
};

export default { promo };
